import { IAddressFieldConfig } from './address/address.interface';
import { ValidatorRule } from '../../app/common/validator/validatorRule.constants';

export const DEFAULT_ADDRESS_FIELD_CONFIG: IAddressFieldConfig[][] = [
    [
        {
            name: 'firstName',
            required: true,
            span: 1,
            order: {
                ja: 1,
                en: 1,
                uk: 1,
                de: 1,
                es: 1,
                'zh-TW': 1,
                'zh-CN': 1,
            },
        },
        {
            name: 'lastName',
            required: true,
            span: 1,
            order: {
                ja: 2,
                en: 2,
                uk: 2,
                de: 2,
                es: 2,
                'zh-TW': 2,
                'zh-CN': 2,
            },
        },
    ],
    [
        {
            name: 'companyName',
            required: false,
            span: 1,
            order: {
                ja: 3,
                en: 3,
                uk: 3,
                de: 3,
                es: 3,
                'zh-TW': 3,
                'zh-CN': 3,
            },
        },
        {
            name: 'phoneNumber',
            required: true,
            span: 1,
            order: {
                ja: 4,
                en: 4,
                uk: 4,
                de: 4,
                es: 4,
                'zh-TW': 4,
                'zh-CN': 4,
            },
        },
    ],
    [
        {
            name: 'country',
            required: true,
            span: 1,
            order: {
                ja: 5,
                en: 5,
                uk: 5,
                de: 5,
                es: 5,
                'zh-TW': 5,
                'zh-CN': 5,
            },
        },
        {
            name: 'state',
            required: false,
            span: 1,
            order: {
                ja: 6,
                en: 6,
                uk: 6,
                de: 6,
                es: 6,
                'zh-TW': 6,
                'zh-CN': 6,
            },
        },
    ],
    [
        {
            name: 'addressLine1',
            required: true,
            span: 2,
            order: {
                ja: 7,
                en: 7,
                uk: 7,
                de: 7,
                es: 7,
                'zh-TW': 7,
                'zh-CN': 7,
            },
        },
    ],
    [
        {
            name: 'addressLine2',
            required: false,
            span: 2,
            order: {
                ja: 8,
                en: 8,
                uk: 8,
                de: 8,
                es: 8,
                'zh-TW': 8,
                'zh-CN': 8,
            },
        },
    ],
    [
        {
            name: 'city',
            required: true,
            span: 1,
            order: {
                ja: 9,
                en: 9,
                uk: 9,
                de: 9,
                es: 9,
                'zh-TW': 9,
                'zh-CN': 9,
            },
        },
        {
            name: 'postcode',
            required: true,
            span: 1,
            order: {
                ja: 10,
                en: 10,
                uk: 10,
                de: 10,
                es: 10,
                'zh-TW': 10,
                'zh-CN': 10,
            },
        },
    ],
];

export const DEFAULT_JP_ADDRESS_FIELD_CONFIG: IAddressFieldConfig[][] = [
    [
        {
            name: 'postalCode',
            required: true,
            span: 1,
            order: {
                ja: 1,
                en: 1,
                'zh-TW': 1,
                'zh-CN': 1,
            },
        },
    ],
    [
        {
            name: 'state',
            required: true,
            span: 2,
            order: {
                ja: 6,
                en: 6,
                'zh-TW': 6,
                'zh-CN': 6,
            },
        },
        {
            name: 'city',
            validatorRules: [
                ValidatorRule.JPCityLengthRule,
                ValidatorRule.EUCJPCharsRule,
                ValidatorRule.FullWidthSpaceRule,
            ],
            required: true,
            span: 2,
            order: {
                ja: 3,
                en: 3,
                'zh-TW': 3,
                'zh-CN': 3,
            },
        },
    ],
    [
        {
            name: 'banchiAddress',
            validatorRules: [ValidatorRule.EUCJPCharsRule, ValidatorRule.FullWidthSpaceRule],
            required: true,
            span: 1,
            order: {
                ja: 4,
                en: 4,
                'zh-TW': 4,
                'zh-CN': 4,
            },
        },
    ],
    [
        {
            name: 'companyName',
            validatorRules: [
                ValidatorRule.JPCompanyLengthRule,
                ValidatorRule.EUCJPCharsRule,
                ValidatorRule.FullWidthSpaceRule,
            ],
            required: false,
            span: 2,
            order: {
                ja: 5,
                en: 5,
                'zh-TW': 5,
                'zh-CN': 5,
            },
        },
        {
            name: 'jobTitle',
            validatorRules: [ValidatorRule.EUCJPCharsRule, ValidatorRule.FullWidthSpaceRule],
            required: false,
            span: 2,
            order: {
                ja: 6,
                en: 6,
                'zh-TW': 6,
                'zh-CN': 6,
            },
        },
    ],
    [
        {
            name: 'phoneNumber',
            required: true,
            span: 2,
            order: {
                ja: 7,
                en: 7,
                'zh-TW': 7,
                'zh-CN': 7,
            },
        },
        {
            name: 'faxNumber',
            required: false,
            span: 2,
            order: {
                ja: 8,
                en: 8,
                'zh-TW': 8,
                'zh-CN': 8,
            },
        },
    ],
    [
        {
            name: 'mobilePhone',
            required: false,
            span: 2,
            order: {
                ja: 9,
                en: 9,
                'zh-TW': 9,
                'zh-CN': 9,
            },
        },
        {
            name: 'mobileEmail',
            required: false,
            span: 2,
            order: {
                ja: 10,
                en: 10,
                'zh-TW': 10,
                'zh-CN': 10,
            },
        },
    ],
];
